import React, {
  ReactElement,
  useEffect,
  useState,
  useCallback,
} from 'react';
import Dialog from '@mui/material/Dialog';
import api from '../../services/api';
import DialogTitle from "@mui/material/DialogTitle";
import {serviceReservationViewTable} from "../../schema/serviceReservationViewTable";
import {Checkbox, DialogContent, IconButton, ListItem, ListItemAvatar, ListItemText, Stack} from "@mui/material";
import List from "@mui/material/List";
import Avatar from "@mui/material/Avatar";
import * as Icons from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";


export const ServiceStatusDialog = ({
  handleClose,
  row,
}: {
  handleClose: () => void;
  row: any;
}): ReactElement => {
  const [loadingRows, setLoadingRows] = useState<any>(false);
  const [rows, setRows] = useState<any>([]);

  const fetchData = useCallback(() => {
    setLoadingRows(true);

    const fastFilterValueTemp = {
      group: {
        id: row?.group?.id,
        name: row?.group?.name,
      },
      activity: {
        id: row?.activity?.id,
        name: row?.activity?.name,
      },
    };

    const searchParams = new URLSearchParams();
    searchParams.set(
      'fast_filter_options',
      JSON.stringify(fastFilterValueTemp)
    );

    serviceReservationViewTable.client.readAll(1, searchParams).then((res: any) => {
      setLoadingRows(false);
      setRows(res);
    });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Dialog
        open={true}
        onClose={handleClose}
      >
        <DialogTitle>
          {row?.name} - Services
        </DialogTitle>
        <DialogContent>

          <List>

            {loadingRows && (
              <Stack justifyContent={'center'} alignItems={'center'}>
                <CircularProgress />
              </Stack>
            )}

            {(!loadingRows && !rows.length) && (
              <ListItem
                sx={{
                  background: '#f9f9f9',
                  borderRadius: '10px',
                  paddingY: '0px'
                }}
              >
                <ListItemText
                  primary={'No available Service'}
                />
              </ListItem>
            )}

            {rows.map((item:any) => {

              const IconComponent =
                Icons[item?.status?.icon?.name as keyof typeof Icons];

              let tooltipValue = item?.status?.name;

              if (item?.status_log && item.status_log.length) {
                const statusLogs = [...(item?.status_log ?? [])]
                  .reverse()
                  .map((statusLogItem: any, index: number) => {
                    return <span key={index}>{statusLogItem}</span>;
                  });

                tooltipValue = <Stack>{statusLogs}</Stack>;
              }
              if (
                item.status_log &&
                !item.status_log.length &&
                item?.service_reservation_status_updated_at
              ) {
                tooltipValue = `${tooltipValue} - ${item.service_reservation_status_updated_at}`;
              }

              if (item?.status_messages) {
                const messages = item?.status_messages.map(
                  (item: any, index: number) => {
                    return (
                      <span
                        key={index}
                        style={{
                          paddingLeft: `${(item?.tab || 0) * 20}px`,
                        }}
                      >
                        {item?.value}
                      </span>
                    );
                  }
                );

                tooltipValue = <Stack>{messages}</Stack>;
              }

              if (item?.warning_reasons && (item?.id === 7 || item?.id === 8 || item?.id === 2)) {
                tooltipValue = (
                  <React.Fragment>
                    {item?.warning_reasons.map((item: any) => {
                      return <p>{item}</p>;
                    })}
                  </React.Fragment>
                );
              }
              
              return (
                <ListItem
                  sx={{
                    background: '#f9f9f9',
                    borderRadius: '10px',
                    paddingY: '0px'
                  }}
                  secondaryAction={
                    <Stack direction={'row'}>

                      <Tooltip
                        sx={{
                          maxWidth: '700px',
                          whiteSpace: 'pre-line',
                        }}
                        disableInteractive
                        title={tooltipValue}
                        slotProps={{
                          tooltip: {
                            sx: {
                              fontSize: '13px',
                              maxWidth: '700px',
                            },
                          },
                          popper: {
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -14],
                                },
                              },
                            ],
                          },
                        }}
                      >
                        <Avatar
                          sx={{
                            background: item?.status?.color?.color,
                            width: 20,
                            height: 20,
                            '& .MuiSvgIcon-root': {
                              fontSize: '16px',
                            },
                          }}
                        >
                          {item?.status?.icon && (
                            <>{IconComponent ? <IconComponent /> : null}</>
                          )}
                        </Avatar>
                      </Tooltip>
                    </Stack>
                  }
                >
                  <ListItemText
                    primary={item?.service?.name}
                    secondary={`${item?.service_provider?.name}`}
                  />
                </ListItem>
              );
            })}
          </List>

        </DialogContent>
      </Dialog>
    </>
  );
};
